import { TableCell, TableHead, TableRow, Typography } from "@mui/material";

const Header = ({ adStatus }: { adStatus: string }) => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>
                    <Typography variant="body2">Campaign</Typography>
                </TableCell>
                <TableCell align="right">
                    <Typography variant="body2">Start Time</Typography>
                </TableCell>
                <TableCell align="right">
                    <Typography variant="body2">End Time</Typography>
                </TableCell>
                <TableCell align="right">
                    <Typography variant="body2">Media</Typography>
                </TableCell>
                {adStatus === "pendingApproval" &&
                    <TableCell align="right" width={300}>
                        <Typography variant="body2">Actions</Typography>
                    </TableCell>
                }
            </TableRow>
        </TableHead>
    )
}

export default Header;
